export default "__VITE_ASSET__0ZXE4Pyi__"